module.exports = __webpack_public_path__ + "img/02.7683fa16.png";